<template>
    <div class="carBox carBoxLeft">
        <el-card class="box-card">
            <div class="mainBody">
                <el-form ref="formValidate" :model="model" :rules="rules" label-width="320px">
                    <el-form-item label="测试模式：" prop="dev_model">
                        <el-radio v-model="model.dev_model" label="0">线上模式</el-radio>
                        <el-radio v-model="model.dev_model" label="1">测试模式</el-radio>
                    </el-form-item>
                    <el-form-item label="审核模式：" prop="sh_model">
                        <el-radio v-model="model.sh_model" label="0">线上模式</el-radio>
                        <el-radio v-model="model.sh_model" label="1">审核模式</el-radio>
                    </el-form-item>
                    <el-form-item label="平台地址：" prop="systemUrl">
                        <el-input v-model="model.systemUrl" style="width: 680px" ></el-input>
                    </el-form-item>
                    <el-form-item label="图片地址：" prop="imgUrl">
                        <el-input v-model="model.imgUrl" style="width: 680px" ></el-input>
                    </el-form-item>
                    <el-form-item label="静态路径：" prop="staticPath">
                        <el-input v-model="model.staticPath" style="width: 680px" ></el-input>
                    </el-form-item>
                    <el-form-item label="COS域名：" prop="cos_domain">
                        <el-input v-model="model.cos_domain" style="width: 680px" ></el-input>
                    </el-form-item>
                    <el-form-item label="微信通知间隔：" prop="limitF">
                        <el-input v-model="model.limitF" class="inputMi" ></el-input>（分钟）
                    </el-form-item>
                    <el-form-item label="进浆流量阈值(运行/停机)：" prop="volume_in_limit">
                        <el-input v-model="model.volume_in_limit" class="inputMi" ></el-input>（L/min）
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" size="medium">保 存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getSysConfig, saveConfig } from '@/api/sysconfig'

export default {
    name: "sysConfig",
    data() {
        return {
            model: {
                dev_model: '0',
                sh_model: '0',
                systemName: '',
                systemUrl: '',
                imgUrl: '',
                staticPath: '',
                cos_domain: '',
                limitF: '',
                volume_in_limit: '',
            },
            rules: {
                systemUrl: [
                    {required: true, message: '平台不能为空', trigger: 'blur'},
                ],
                imgUrl: [
                    {required: true, message: '图片不能为空', trigger: 'blur'},
                ],
                staticPath: [
                    {required: true, message: '静态路径不能为空', trigger: 'blur'},
                ],
                cos_domain: [
                    {required: true, message: 'COS域名不能为空', trigger: 'blur'},
                ],
                limitF: [
                    {required: true, message: '微信通知间隔不能为空', trigger: 'blur'},
                ],
                volume_in_limit: [
                    {required: true, message: '进浆流量阈值不能为空', trigger: 'blur'},
                ]
            }
        }
    },
    mounted(){
        this.getData()
    },
    methods: {
        getData(){
            getSysConfig().then(res=>{
                if(res.code ==1){
                    let config = JSON.parse(res.data.config_str)
                    this.model.dev_model = config.dev_model
                    this.model.sh_model = config.sh_model
                    this.model.systemName = config.systemName
                    this.model.systemUrl = config.systemUrl
                    this.model.imgUrl = config.imgUrl
                    this.model.staticPath = config.staticPath
                    this.model.cos_domain = config.cos_domain
                    this.model.limitF = config.limitF+""
                    this.model.volume_in_limit = config.volume_in_limit+""
                }
            })
        },
        handleSubmit(){
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    this.model.limitF = this.model.limitF+""
                    let config_str = JSON.stringify(this.model)
                    saveConfig(config_str).then(res=>{
                        if(res.code ==1){
                            this.$msgs("保存成功！");
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>